export function scaleQuantity(base: number, targetServings: number, baseServings: number): number {
  if (baseServings <= 0) return base;
  const scaled = (base * targetServings) / baseServings;
  return Math.round(scaled * 100) / 100;
}

export function formatQuantity(q: number): string {
  if (!Number.isFinite(q)) return '';
  if (Number.isInteger(q)) return String(q);
  const rounded = Math.round(q * 100) / 100;
  return String(rounded).replace(/\.?0+$/, '');
}

export function formatIngredient(params: {
  name: string;
  quantity: number;
  unit?: string | null;
}): string {
  const { name, quantity, unit } = params;
  const q = formatQuantity(quantity);
  if (unit) return `${q} ${unit} ${name}`;
  return `${q} ${name}`.trim();
}
